/*
 * @Author: 杨振峰
 * @Date: 2019-11-22 10:55:26
 * @Last Modified by: 杨振峰
 * @Last Modified time: 2019-11-22 14:30:50
 * @Desc
 */

function isQuotaExceeded (e) {
  var quotaExceeded = false
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true
          break
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true
          }
          break
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true
    }
  }
  return quotaExceeded
}

const plugin = {
  install (Vue, opts) {
    opts = Object.assign({}, opts)

    Object.defineProperty(Vue.prototype, '$storage', {
      value: {
        get (key) {
          var value = window.localStorage.getItem(key)
          return null || JSON.parse(value)
        },
        set (key, value) {
          try {
            window.localStorage.setItem(key, JSON.stringify(value))
            return true
          } catch (e) {
            if (isQuotaExceeded(e)) {
              return false
            }
          }
        },
        remove (key) {
          var value = window.localStorage.getItem(key)
          window.localStorage.removeItem(key)
          return value
        },
        clear () {
          window.localStorage.clear()
        }
      }
    })
  }
}

export default plugin
